import { bridge, isWeb } from 'shared/src/utils';

/**
 * 배송지 flow 종료.
 * - native: hosting 인스턴스 닫기 (bridge.closeInstance)
 * - 웹: closeInstance가 no-op이라 화면이 잔류하므로 브라우저 히스토리 back으로 이탈
 */
export const closeAddressFlow = (instanceId: string) => {
  if (isWeb) {
    window.history.back();
    return;
  }
  bridge.closeInstance({ instanceId, animated: true });
};
